import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, NavLink } from 'react-router-dom';
import { Navbar, Nav, NavItem, NavbarBrand, Collapse, NavbarToggler, NavDropdown,DropdownToggle,DropdownMenu, DropdownItem,MenuItem  } from 'reactstrap';
import { userExpirationDate } from '../utils/account-detail';
import getPortalLocData from '../config/loc';

class PrivateRoute extends React.Component {
    constructor(props) {
        super(props);
        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.toggleNavbardropdown = this.toggleNavbardropdown.bind(this);
       
        this.state = {
          collapsed: true,
          modalContact: false,
          dropdown:false
          
        };
       

    }

    toggleNavbar() {
        this.setState({
          collapsed: !this.state.collapsed
        });
    }
    toggleNavbardropdown() {
        this.setState({
            dropdown: !this.state.dropdown
        });
    }

  


    render() {
        let { 
            component: Component, 
            loginActions,
            authentication,
            ...rest } = this.props;

        return (<Route {...rest} render={props => {
            const activeStyle = { color: 'white' };


            return (<div className="main">
                <div className="header_menu">
                    <Navbar className="limit-content navbar-expand-md navbar__mobilefix" color="faded" dark>
                    <NavbarBrand href={"/"} to="/" className="mr-auto">
                        <div>
                            <img className="logoLink" src={"/images/" + getPortalLocData().name +  "/site_logo.png"} alt="Banner" title="Banner"/>
                        </div>
                    </NavbarBrand>
                    
                    {getPortalLocData().name === 'conventionCentre' && 
                        <div>
                            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                                <Nav className="collapse-mobile" navbar>
                                    <NavItem>
                                        <a className="nav-link" href="https://www.easytrip.ie/">Home</a>
                                    </NavItem>
                                    <NavItem>
                                        <a className="nav-link" href="https://www.easytrip.ie/easytrip-personal/parking/">Parking</a>
                                    </NavItem>
                                    <NavItem>
                                        <a className="nav-link" href="https://www.easytrip.ie/easytrip-personal/toll-tag-car-wash/">Car Wash</a>
                                    </NavItem>
                                    <NavItem>
                                        <a className="nav-link" href="https://vip.easytrip.ie/">Insurance</a>
                                    </NavItem>
                                    <NavItem>
                                        <a className="nav-link" href="https://www.easytrip.ie/easytrip-business/">Business</a>
                                    </NavItem>
                                    {
                                        authentication && authentication.loggedIn && authentication.data && authentication.data.user ? <NavDropdown isOpen={this.state.dropdown} toggle={this.toggleNavbardropdown}>
                                            <DropdownToggle color="primary" nav caret>
                                                {authentication.data.user.firstName}{" "}{authentication.data.user.lastName}
                                            </DropdownToggle>
                                            <DropdownMenu >
                                                <DropdownItem className="nav-droupdown" onClick={() => loginActions.logout()}>Logout</DropdownItem>
                                            </DropdownMenu>

                                        </NavDropdown> : null
                                    }

                                </Nav>
                            <Collapse isOpen={!this.state.collapsed} navbar onClick={this.toggleNavbar}>
                                <Nav className="ml-auto navbar__mobile" navbar>
                                    <NavItem>
                                        <a className="nav-link" href="https://www.easytrip.ie/">Home</a>
                                    </NavItem>
                                    <NavItem>
                                        <a className="nav-link" href="https://www.easytrip.ie/easytrip-personal/parking/">Parking</a>
                                    </NavItem>
                                    <NavItem>
                                        <a className="nav-link" href="https://www.easytrip.ie/easytrip-personal/toll-tag-car-wash/">Car Wash</a>
                                    </NavItem>
                                    <NavItem>
                                        <a className="nav-link" href="https://vip.easytrip.ie/">Insurance</a>
                                    </NavItem>
                                    <NavItem>
                                        <a className="nav-link" href="https://www.easytrip.ie/easytrip-business/">Business</a>
                                    </NavItem>
                                    <NavItem>
                                        <a className="nav-link" onClick={() => loginActions.logout()} >Logout</a>
                                    </NavItem>
                                </Nav>
                            </Collapse>
                        </div>

                        }



                        {getPortalLocData().name === 'airport' && 
                            <div>
                                <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                                    <Nav className="collapse-mobile" navbar>
                                        <NavItem>
                                            <a className="nav-link" href="/">Home</a>
                                        </NavItem>
                                        <NavItem>
                                            <a className="nav-link" href="/about-us/">About Us</a>
                                        </NavItem>
                                        <NavItem>
                                            <a className="nav-link" href="/contact-us/">Contact</a>
                                        </NavItem>
                                        {
                                            authentication && authentication.loggedIn && authentication.data && authentication.data.user ? <NavDropdown isOpen={this.state.dropdown} toggle={this.toggleNavbardropdown}>
                                                <DropdownToggle color="primary" nav caret>
                                                    {authentication.data.user.firstName}{" "}{authentication.data.user.lastName}
                                                </DropdownToggle>
                                                <DropdownMenu >
                                                    <DropdownItem className="nav-droupdown" onClick={() => loginActions.logout()}>Logout</DropdownItem>
                                                </DropdownMenu>

                                            </NavDropdown> : null
                                        }

                                    </Nav>
                                <Collapse isOpen={!this.state.collapsed} navbar onClick={this.toggleNavbar}>
                                    <Nav className="ml-auto navbar__mobile" navbar>
                                        <NavItem>
                                            <a className="nav-link" href="/">Home</a>
                                        </NavItem>
                                        <NavItem>
                                            <a className="nav-link" href="/about-us/">About Us</a>
                                        </NavItem>
                                        <NavItem>
                                            <a className="nav-link" href="/contact-us/">Contact</a>
                                        </NavItem>
                                        <NavItem>
                                            <a className="nav-link" onClick={() => loginActions.logout()} >Logout</a>
                                        </NavItem>
                                    </Nav>
                                </Collapse>
                            </div>
                        }

                    </Navbar>
                </div>
                {/* <div className="menu-pages"></div> */}
                <div className="">
                    <Component {...props} />
                </div>

            </div>)

           
        }} />);
    }
}

PrivateRoute.propTypes = {
    component: PropTypes.func.isRequired,
    location: PropTypes.object,
    history: PropTypes.object,
    loginActions: PropTypes.object,
    authentication:PropTypes.object
};

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/PrivateRoute.jsx